var _rect, _text, _text2, _rect2, _text3, _text4, _text5, _rect3, _text6, _rect4, _text7, _rect5, _text8, _text9, _text10, _rect6, _text11, _rect7, _text12, _rect8, _text13, _rect9, _text14, _text15, _text16, _line, _polygon, _rect10, _text17, _text18, _text19, _text20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase7Fig2RoleTiersMeasured(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1120 560",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1120,
    height: 560,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The measured tier assignment")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Authoring on the top model at low effort, auditing on the second model at high effort")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 110,
    width: 540,
    height: 170,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 142,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "ROLE, AUTHORING")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 172,
    fontSize: 18,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Authoring")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 196,
    fontSize: 13,
    fill: "#4A5F56"
  }, "Writes the first draft of every play in the playbook.")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 218,
    width: 158,
    height: 30,
    rx: 15,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 238,
    fontSize: 12,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "TOP MODEL TIER")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 218,
    width: 118,
    height: 30,
    rx: 15,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 305,
    y: 238,
    fontSize: 12,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "LOW EFFORT")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 300,
    width: 540,
    height: 170,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 332,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "ROLE, AUDITING")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 362,
    fontSize: 18,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Auditing")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 386,
    fontSize: 13,
    fill: "#4A5F56"
  }, "Reads each finished play cold and scores it.")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 408,
    width: 180,
    height: 30,
    rx: 15,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 166,
    y: 428,
    fontSize: 12,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "SECOND MODEL TIER")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 408,
    width: 124,
    height: 30,
    rx: 15,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 428,
    fontSize: 12,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "HIGH EFFORT")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 636,
    y: 110,
    width: 436,
    height: 360,
    rx: 12,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "6 4"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 140,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "COLD AUDIT RESULT")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 156,
    width: 388,
    height: 130,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 684,
    y: 186,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#DC2626"
  }, "BEFORE, AUTHORING TIER MISASSIGNED")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 684,
    y: 228,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 30,
    fontWeight: 700,
    fill: "#DC2626"
  }, "0 clean")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 684,
    y: 256,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "of 17 plays")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 854,
    y1: 292,
    x2: 854,
    y2: 306,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "854,312 849,304 859,304",
    fill: "#6B7F74"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 318,
    width: 388,
    height: 130,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 684,
    y: 348,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "AFTER, TIERS SPLIT BY ROLE")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 684,
    y: 390,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 30,
    fontWeight: 700,
    fill: "#16A34A"
  }, "10 of 10")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 684,
    y: 418,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "cold audits green")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 526,
    fontSize: 13,
    fill: "#4A5F56"
  }, "Two populations: the failing sweep covered the 17 plays live at the time, and 10 cold audits ran after the tiers were corrected.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase7Fig2RoleTiersMeasured);
export default __webpack_public_path__ + "static/media/case7-fig2-role-tiers-measured.e184c5057fcad5343c62e33f3a70d344.svg";
export { ForwardRef as ReactComponent };